import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess200105Status: 'idle',
    startProcess200105Error: undefined as any,
    loadUserParamsProcess200105Status: 'idle',
    loadUserParamsProcess200105Error: undefined as any,

    process200105List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess200105 = createAsyncThunk('process200105Slice/startProcess200105', async ({ process200105 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess200105/`,
        prepareData(process200105),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess200105Status } = getState().process200105Slice
        return startProcess200105Status !== 'pending'
    }
})

export const loadUserParamsProcess200105 = createAsyncThunk('process200105Slice/loadUserParamsProcess200105', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess200105/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess200105Status } = getState().process200105Slice
        return loadUserParamsProcess200105Status !== 'pending'
    }
})

const Process200105Slice = createSlice({
    name: 'process200105Slice',
    initialState,
    reducers: {
        resetstartProcess200105: (state) => {
            state.job = undefined
            state.startProcess200105Error = undefined
        },
        resetstartProcess200105Error: (state) => {
            state.startProcess200105Error = undefined
        },
        resetloadUserParamsProcess200105: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess200105Error = undefined
        },
        resetloadUserParamsProcess200105Error: (state) => {
            state.loadUserParamsProcess200105Error = undefined
        },
        removeFromProcess200105ListById: (state, action) => {
            state.process200105List = state.process200105List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess200105ListByIds: (state, action) => {
            state.process200105List = state.process200105List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process200105List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess200105Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process200105List = []
            state.startProcess200105Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess200105.pending, (state) => {
            state.startProcess200105Status = 'pending'
            state.startProcess200105Error = undefined
        })
        builder.addCase(startProcess200105.fulfilled, (state, action) => {
            state.startProcess200105Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess200105.rejected, (state, action) => {
            state.startProcess200105Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess200105Error = action.error.message
            } else {
                state.startProcess200105Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess200105.pending, (state) => {
            state.loadUserParamsProcess200105Status = 'pending'
            state.loadUserParamsProcess200105Error = undefined
        })
        builder.addCase(loadUserParamsProcess200105.fulfilled, (state, action) => {
            state.loadUserParamsProcess200105Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess200105.rejected, (state, action) => {
            state.loadUserParamsProcess200105Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess200105Error = action.error.message
            } else {
                state.loadUserParamsProcess200105Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess200105,
    resetstartProcess200105Error,
    resetloadUserParamsProcess200105,
    resetloadUserParamsProcess200105Error,
    removeFromProcess200105ListById,
    removeFromProcess200105ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process200105Slice.actions
export default Process200105Slice.reducer
